import React, { CSSProperties } from "react";
import { Select } from "antd";

type ModalHeaderProps = {
  title: string;
  value?: number | string;
  options?: { label: string | number; value: string | number }[];
  onChange?: (value: any) => void;
  rightContent?: React.ReactNode; // for flexibility
  style?: CSSProperties; // allow custom styles if needed
  isLoading?: boolean;
};

export const ModalHeader = ({ title, value, options = [], onChange, rightContent, style = {} }: ModalHeaderProps) => {
  const [selectValue, setSelectValue] = React.useState(value);
  const changeHandler = (e) => {
    onChange && onChange(e);
    setSelectValue(e);
  };

  const defaultStyle: CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    bottom: "4px",
  };

  return (
    <div style={{ ...defaultStyle, ...style }}>
      {/* Left */}
      <span style={{ fontWeight: 600 }}>{title}</span>

      {/* Right */}
      {rightContent ? (
        rightContent
      ) : options && options?.length > 0 ? (
        <div className="modalHeaderSelect">
          {<Select value={selectValue} style={{ width: 150 }} onChange={changeHandler} options={options} />}
        </div>
      ) : null}
    </div>
  );
};
